<template>
  <div class="tier-selector">
    <div class="non-mobile">
      <div v-for="i in 8" class="checkbox">
        <label v-bind:class="{ disabled: disabled }">
          <input
            type="checkbox"
            v-bind:disabled="disabled"
            v-bind:checked="isTierInRange(i)"
            v-bind:indeterminate.prop="isTierInRange(i) === 'partially'"
            v-on:change="selectOrDeselectGeneralHandsFromTier(i)"
          >
          Tier {{ i }}
        </label>
      </div>
      <hr>
      <p v-if="loggedIn" class="customize"><router-link to="/settings/general/tiers"><small>Customize tiers</small></router-link></p>
    </div>
    <div class="mobile">
      <div class="btn-group btn-group-justified">
        <div v-for="i in 4" class="btn-group">
          <button
            class="btn btn-default"
            v-bind:disabled="disabled"
            v-bind:class="{ 'active': isTierInRange(i) }"
            v-on:click="selectOrDeselectGeneralHandsFromTier(i)"
          >
            {{ i }}
          </button>
        </div>
      </div>
      <br/>
      <div class="btn-group btn-group-justified">
        <div v-for="i in 4" class="btn-group">
          <button
            class="btn btn-default"
            v-bind:disabled="disabled"
            v-bind:class="{ 'active': isTierInRange(i + 4) }"
            v-on:click="selectOrDeselectGeneralHandsFromTier(i + 4)"
          >
            {{ i + 4 }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utilities from '@/services/utilities/utilities';

export default {
  name: 'tier-selector',
  props: ['generalHands', 'disabled'],
  computed: {
    loggedIn: function () {
      return this.$store.getters['account/loggedIn'];
    },
  },
  methods: {
    isTierInRange: function (tierNumber) {
      return utilities.hands.areGeneralHandsInRange(this._getGeneralHandStringsFromTier(tierNumber), this.generalHands);
    },
    _getGeneralHandStringsFromTier: function (tierNumber) {
      return this.$store.state.account.user.settings.general.tiers[tierNumber - 1];
    },
    selectOrDeselectGeneralHandsFromTier: function (tierNumber) {
      let generalHandStringsFromTier = this._getGeneralHandStringsFromTier(tierNumber);

      if (this.isTierInRange(tierNumber)) {
        this.$emit('deselectGeneralHands', generalHandStringsFromTier);
      } else {
        this.$emit('selectGeneralHands', generalHandStringsFromTier);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "src/assets/mixins";

  .mobile {
    display: none;
  }

  .checkbox:first-child {
    margin-top: 0px;
  }

  .btn-default:focus, .btn-default:hover {
    background-color: white !important;
  }

  .btn-default.active:focus, .btn-default.active:hover {
    background-color: #e6e6e6 !important;
  }

  .checkbox label {
    @include noselect();

    input[type="checkbox"] {
      bottom: 2px;
    }

    &.disabled {
      cursor: not-allowed;
    }
  }

  .customize a {
    color: #333;
  }

  @media (max-width: 672px) {
    .tier-selector .mobile {
      display: block;
      max-width: 350px;
      width: 100%;
      margin-top: 10px;
      margin-left: 0px;
    }

    .tier-selector .non-mobile {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/hand-range/tier-selector.vue